import React from 'react'

import { MainFullContainer } from 'components/Layout/AppLayout'

import './index.css'
import Header from './Header'
import List from './List'

class Activity extends React.Component {
  render() {
    return (
      <MainFullContainer>
        <Header />
        <List />
      </MainFullContainer>
    )
  }
}

export default Activity
